import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {VenueListComponent} from '../venue-list/venue-list.component';
const routes: Routes = [
  {
    path:'',
    component:VenueListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VenueListRoutingModule { }  
